import React, { lazy, Suspense } from 'react';

const LazyAddSale = lazy(() => import('./AddSale'));

const AddSale = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyAddSale {...props} />
  </Suspense>
);

export default AddSale;
